import { primaryNav } from '@/config/nav'
import { NavLink } from '@/components/layout/nav-link'

function DesktopNav() {
  return (
    <nav aria-label="Primary" className="hidden items-center gap-6 md:flex">
      {primaryNav.map((item) => (
        <NavLink key={item.href} to={item.href}>
          {item.label}
        </NavLink>
      ))}
    </nav>
  )
}

export { DesktopNav }
